import { PageViewEventLogger, useUserEventLogger } from '@repo/tracking-service';
import { useDialog } from '@repo/ui';
import { AuthGuard } from '@repo/user-session';
import { useRouter } from 'next/router';

import Layout from '@/components/layout/Layout';
import { getCorporationRefundData } from '@/components/tax-refund/common/data/corporation-refund-data';
import HometaxSessionError from '@/components/tax-refund/common/view/ErrorView/HometaxSessionError';
import { COMMON_PATHS, CORPORATION_PATHS } from '@/lib/constants/paths';
import { checkHometaxAvailableTime } from '@/lib/utils/hometax-time';

const CorporationHometaxSessionErrorPage = () => {
  const router = useRouter();
  const { showDialog } = useDialog();
  const refundData = getCorporationRefundData();
  const { sendClickEvent } = useUserEventLogger();

  const checkHometaxHour = () => {
    // 오전 6시 ~ 밤 0시 아닌 경우 홈택스 조회 불가
    if (!checkHometaxAvailableTime()) {
      showDialog({
        title: '아침 6시 이후에 조회해주세요',
        description: '매일 밤 0시부터 아침 6시까지 홈택스 점검으로 환급액 조회가 어려워요.'
      });
      return false;
    }
    return true;
  };

  const handleClickExit = () => {
    sendClickEvent('corps-lookup_error-session_close');
    router.push({
      pathname: `${COMMON_PATHS.환급조회목록}`,
      query: router.query
    });
  };

  const handleRetry = () => {
    sendClickEvent('corps-lookup_error-session_retry');
    if (checkHometaxHour()) {
      switch (refundData?.authType) {
        case 'hometax':
          router.push({
            pathname: `${CORPORATION_PATHS.홈택스아이디입력}`,
            query: router.query
          });
          break;
        case 'joint-certificate':
          router.push({
            pathname: `${CORPORATION_PATHS.법인공동인증서선택}`,
            query: router.query
          });
          break;
        default:
          router.push({
            pathname: `${COMMON_PATHS.환급조회목록}`,
            query: router.query
          });
          break;
      }
    }
  };

  return (
    <AuthGuard>
      <PageViewEventLogger pageName="corps-lookup_error-session" />
      <Layout
        rightTextButton={{
          label: '나가기',
          state: 'gray',
          onClick: handleClickExit
        }}
      >
        <HometaxSessionError onPrimaryButtonClick={handleRetry} />
      </Layout>
    </AuthGuard>
  );
};

export default CorporationHometaxSessionErrorPage;
